import axios from "axios";
import { notify } from "@kyvg/vue3-notification";

export default {
	namespaced: true,

	state: () => ({
		fileReferencesList: [],
		excelReferencesList: null,
		availableProfiles: [],
		calculatedProfiles: {
			data: [],
			total: null,
		},
		reportUsers: {
			data: [],
			total: null,
		},
		listState: {
			currentPage: null,
			sortField: null,
			sortOrder: null,
		},
		stateDetailList: {
			currentPage: null,
			sortField: null,
			sortOrder: null,
			status: null,
		},
		detailReportUsers: {
			data: [],
			total: null,
		},

		referenceProfile: null,
		currentProfileTitle: null,
		parsedUsers: null,
	}),

	mutations: {
		setFileReferencesList(state, data) {
			state.fileReferencesList = data;
		},
		setExcelReferencesList(state, data) {
			state.excelReferencesList = data;
		},
		deleteReferenceExcel(state, id) {
            state.fileReferencesList
			= state.fileReferencesList
			.filter((profile) => {return profile.id != id});
        },
		setAvailableProfiles(state, data) {
			state.availableProfiles = data;
		},
		setCalculatedProfiles(state, data) {
			state.calculatedProfiles.data = data.data ?? [];
			state.calculatedProfiles.total = data.total ?? null;
		},
		setReportUsers(state, data) {
			state.calculatedProfiles.data = data.data ?? [];
			state.calculatedProfiles.total = data.total ?? null;
		},
		setListState(state, payload) {
			state.ListState = {
				...payload,
			};
		},
		clearListState(state) {
			state.ListState = {
				currentPage: null,
				sortField: null,
				sortOrder: null,
			};
		},
		setStateDetailList(state, payload) {
			state.stateDetailList = {
				...payload,
			};
		},
		clearStateDetailList(state) {
			state.stateDetailList = {
				currentPage: null,
				sortField: null,
				sortOrder: null,
				status: null
			};
		},
		setReport(state, data) {
			state.referenceProfile = data;
			state.currentProfileTitle = data?.title ?? null;
		},
		clearReport(state) {
			state.referenceProfile = null;
			state.currentProfileTitle = null;
		},
		setDetailReportUsers(state, data) {
			state.detailReportUsers.data = data.data ?? [];
			state.detailReportUsers.total = data.total ?? null;
		},
		setParsedUsers(state, data) {
			state.parsedUsers = data;
		},
		clearParsedUsers(state) {
			state.parsedUsers = null;
		}
	},

	actions: {
		async getReferencesFilesList({ commit }) {
			await axios.get(`/reference_profiles/excel`).then(({ data }) => {
				commit("setFileReferencesList", data)
			})
		},
		loadReferencesExcel({ commit }, data) {
			let request = new FormData()
			request.append("file", data.file)
			request.append("position_for", data.position_for)
			request.append("calculation_period", data.calculation_period)
			axios.post(`/reference_profiles/excel`, request).then(({ data }) => {
				commit("setExcelReferencesList", data);
				notify({
					title: "Файл загружен",
					type: "success"
				})
			})
		},
		async deleteReferenceExcel({ commit }, id) {
            await axios.delete(`/reference_profiles/excel/${id}`)
                .then(() => {
                    commit("deleteReferenceExcel", id)
                    notify({
                        type: "success",
                        title: "Операция прошла успешно"
                    })
                })
        },

		async getAvailableProfiles({ commit }) {
			await axios.get('/reference_profiles/available_profiles')
				.then(({ data }) => {
					commit("setAvailableProfiles", data)
				})
		},

		async getCalculatedProfiles({ commit }, request) {
			await axios.post('/reference_profiles/profiles', request)
				.then(({ data }) => {
					commit("setCalculatedProfiles", data)
				})
		},

		async updateReferenceTitle({ commit }, request) {
			await axios.post(`/reference_profiles/${request.id}/rename`, request)
		},

		async deleteReferenceProfile({ commit }, request) {
			await axios.delete(`/reference_profiles/${request.id}`)
		},

		async getReportUsers({ commit }, request) {
			await axios.post(`/reference_profiles/${request.id}/users/detail`, request)
				.then(({ data }) => {
					commit("setDetailReportUsers", data)
				})
		},

		async deleteUsersFromReport({ commit }, request) {
			await axios.post(`/reference_profiles/${request.id}/users/delete`, request)
				.then(({ data }) => {
					commit("setDetailReportUsers", data)
				})
		},

		async getReferenceProfile({ commit }, request) {
			await axios.get(`/reference_profiles/${request.id}`, request)
				.then(({ data }) => {
					commit("setReport", data)
				})
		},

		async parseUsersFromExcel({ commit }, data) {
			await axios.post(`/reference_profiles/excel`, data)
				.then(({ data }) => {
					commit("setParsedUsers", data)
				})
		},

		async uploadUsersToReport({ commit }, data) {
			await axios.post(`/reference_profiles/add/users`, data);
		},
	}
}
